import React from "react";
import IGestionFacturation from "../../models/IGestionFacturation";


interface ISommaireFacturationProps {
    gestionFacturation: IGestionFacturation
};

export default function GestionFacturationSommaire({gestionFacturation}: ISommaireFacturationProps) {
    return <>
        <div className="item-facturation">
            <strong>Sous total:</strong>
            <strong>{(gestionFacturation?.sousTotal || 0 + gestionFacturation?.montantEscompte || 0).toFixed(2)} $</strong>
        </div>
        <div className="item-facturation">
            <label>Escompte/Promotion(s):</label>
            <span>{gestionFacturation?.montantEscompte?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation">
            <strong>Sous-total avec Escompte:</strong>
            <span>{gestionFacturation?.sousTotal?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation">
            <label>Frais de services:</label>
            <span>{gestionFacturation?.montantFraisServices?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation">
            <label>Taxes hebergement:</label>
            <span>{gestionFacturation?.montantTaxeHebergement?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation">
            <label>TPS:</label>
            <span>{gestionFacturation?.montantTps?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation">
            <label>TVQ:</label>
            <span>{gestionFacturation?.montantTvq?.toFixed(2)}$</span>
        </div>
        <div className="item-facturation" style={{borderTop: "1px solid #e5e8f0"}}>
            <strong>Grand total:</strong>
            <strong>{gestionFacturation?.montantFacture?.toFixed(2)} $</strong>
        </div>
        <div className="item-facturation">
            <label>Paiement:</label>
            <span>{gestionFacturation?.montantPaiement?.toFixed(2)} $</span>
        </div>
        <div className="item-facturation" style={{borderTop: "1px solid #e5e8f0"}}>
            <strong>Solde:</strong>
            <strong style={gestionFacturation.solde < 0 ? {color: "red"} : {}}>{gestionFacturation?.solde?.toFixed(2)} $</strong>
        </div>
    </>;
}